import React from "react";
import { useFormatPrice } from "hooks";

const ProdWidget = ({ value }) => {
  const formatPrice = useFormatPrice();

  const renderContent = () => {
    switch (value.prodType) {
      case 1:
        return (
          <div className="flex flex-col gap-[1px]">
            <span className="text-[15px]">{value.prodTitle}</span>
            <span className="text-[12px] font-bold text-gray-500">
              {value?.prod?.skuCode} | {formatPrice(value?.prod?.rtlPrice)}
            </span>
          </div>
        );
      case 2:
        return (
          <div className="flex flex-col gap-[1px]">
            <span className="text-[15px]">{value.prodTitle}</span>
            <span className="text-[12px] font-bold text-gray-500">
              {value?.varProd?.skuCode} |{" "}
              {formatPrice(value?.varProd?.rtlPrice)}
            </span>
          </div>
        );
      default:
        return "-";
    }
  };

  return renderContent();
};

export default ProdWidget;
